import React from 'react';

import Chip from '@mui/material/Chip';

import { RequestStatus } from 'stores/ContractRequestStoreAdapter';

const RequestStatusColor: Record<RequestStatus, string> = {
  ADJUSTING: '#757575',
  SUBMITTED: '#1976d2',
  IN_PROGRESS: '#ed6c02',
  APPROVED: '#2e7d32',
  REJECTED: '#d32f2f',
  CANCELLED: '#9e9e9e',
};

type Props = {
  requestStatus: RequestStatus;
  size?: 'small' | 'medium';
};

const RequestStatusChip: React.FC<Props> = ({ requestStatus, size = 'small' }) => {
  const color = RequestStatusColor[requestStatus];
  return (
    <Chip
      label={RequestStatus[requestStatus]}
      size={size}
      sx={{
        color: '#fff',
        backgroundColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default RequestStatusChip;
